<template>
    <div class="text-center">
        <v-row>
            <v-col class="mb-4">
                <template v-if="needsLogin">
                    <h2>Hey liebe Krümel Eltern!</h2>
                    <p>
                        Bevor ihr zu den Tools kommt, müsst ihr euch einmal bitte einloggen.
                        <br />
                        Falls ihr noch keinen Account habt, könnt ihr
                        <router-link
                            to="/sign-up"
                        >
                            diesen hier ganz schnell ohne große Freischalterei erstellen.
                        </router-link>
                        <br />
                        Wenn ihr noch Fragen habt, fragt einfach in der Krümel WhatsApp Gruppe.
                    </p>
                </template>
                <template v-else>
                    <v-alert
                        outlined
                        type="success"
                        prominent
                        border="left"
                    >
                        <h3>Super - Moin {{ username }}!</h3>
                        Du wirst nun weitergeleitet...
                    </v-alert>
                </template>
                <v-dialog v-model="showLogin"
                          v-if="needsLogin"
                          transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-row>
                            <v-col class="mb-4">
                                <v-btn
                                    class="mx-2"
                                    fab
                                    dark
                                    color="cyan"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon
                                        large
                                        dark
                                    >
                                        mdi-account-lock
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <v-container class="white">
                        <v-row class="text-center">
                            <v-col>
                                <login />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Login from '../pages/Login'

export default {
    name: 'Index',
    components: {
        Login
    },
    data() {
        return {
            showLogin: false
        }
    },
    async created() {
        if (!this.needsLogin) {
            this.$router.push('/mealplan')
        }
    },
    computed: {
        needsLogin() {
            return !this.$store.getters.isLoggedIn
        },
        username() {
            return this.$store.getters.getUser.username
        }
    },
    watch: {
        needsLogin(val) {
            if (!val) {
                setTimeout(() => {
                    this.$router.push('/mealplan')
                }, 4000)
            }
        }
    }
}
</script>
